exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".view-content .plyr--video{height:100%}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/ViewVideo.vue"],"names":[],"mappings":"AACA,2BAA2B,WAAW,CACrC","file":"ViewVideo.vue","sourcesContent":["\n.view-content .plyr--video{height:100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2db140c0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-review/components/AnswerFileFullScreen/src/ViewVideo.vue
// module id = 1840
// module chunks = 5 34 108